import {http} from '../http'

/**
 * Função que realiza uma requisição GET usando o axios
 * @param url
 * @returns Promise
 */
function _get (url) {
  return http.get(url).then(response => response.data)
}

/**
 * Função que realiza uma requisição POST usando o axios
 * @param url
 * @param data
 * @returns Promise
 */
function _post (url, data) {
  return http.post(url, data).then(response => response.data)
}

/**
 * Função que realiza uma requisição PUT usando o axios
 * @param url
 * @param data
 * @returns Promise
 */
function _put (url, data) {
  return http.put(url, data).then(response => response.data)
}

/**
 * Função que realiza uma requisição DELETE usando o axios
 * @param url
 * @returns Promise
 */
function _destroy (url) {
  return http.delete(url).then(response => response.data)
}

export const get = _get
export const post = _post
export const put = _put
export const destroy = _destroy
